var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMyNotifications = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.03033 14.1682C5.14233 14.4643 5.15778 14.7882 5.0745 15.0936L3.63761 20.3622L8.90618 18.9253C9.21157 18.842 9.53549 18.8575 9.83156 18.9695C10.7368 19.3119 11.7196 19.5 12.7498 19.5C17.3061 19.5 20.9998 15.8063 20.9998 11.25C20.9998 6.69365 17.3061 3 12.7498 3C8.19344 3 4.49979 6.69365 4.49979 11.25C4.49979 12.2802 4.6879 13.263 5.03033 14.1682ZM3.62735 14.6989C3.22176 13.6267 2.99978 12.4643 2.99978 11.25C2.99978 5.86522 7.36501 1.5 12.7498 1.5C18.1346 1.5 22.4998 5.86522 22.4998 11.25C22.4998 16.6348 18.1346 21 12.7498 21C11.5355 21 10.3731 20.778 9.30086 20.3724L2.76604 22.1547C2.20616 22.3074 1.69243 21.7936 1.84513 21.2337L3.62735 14.6989ZM8.15618 9.75C8.15618 9.33579 8.49197 9 8.90618 9H16.5C16.9142 9 17.25 9.33579 17.25 9.75C17.25 10.1642 16.9142 10.5 16.5 10.5H8.90618C8.49197 10.5 8.15618 10.1642 8.15618 9.75ZM8.90618 12C8.49197 12 8.15618 12.3358 8.15618 12.75C8.15618 13.1642 8.49197 13.5 8.90618 13.5H13.5C13.9142 13.5 14.25 13.1642 14.25 12.75C14.25 12.3358 13.9142 12 13.5 12H8.90618Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMyNotifications);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/my-notifications.8378496d408669790eee3c33628978b9.svg";